import { render } from "./DocumentLabel.vue?vue&type=template&id=29c5874e&scoped=true"
import script from "./DocumentLabel.vue?vue&type=script&lang=js"
export * from "./DocumentLabel.vue?vue&type=script&lang=js"

import "../../assets/scss/document_annotations.scss?vue&type=style&index=0&id=29c5874e&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c5874e"]])

export default __exports__